import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { map, share, catchError, take, filter } from 'rxjs/operators';
interface IPResponse {
  ip: string;
}
const IP_ADDRESS_SERVICE_URL = 'https://api.ipify.org?format=json';
let ipAddressObservable: Observable<string>;
let ipAddressValue: string;
@Injectable()
export class IpAddressService {
  private http: HttpClient;
  constructor(injector: Injector) {
    setTimeout(() => {
      this.http = injector.get(HttpClient);
      const existingRequest = ipAddressObservable;
      if (!existingRequest) {
        ipAddressObservable = this.http.get<IPResponse>(IP_ADDRESS_SERVICE_URL).pipe(
          share(),
          take(1),
          map(data => data.ip),
          catchError(() => {
            // There was an error retrieving the IP address from the external service
            // probably because of an ad-blocker
            return EMPTY;
          })
        );
        ipAddressObservable
          .pipe(filter(ipAddress => !!ipAddress))
          .subscribe(ipAddress => (ipAddressValue = ipAddress));
      }
    });
  }
  public get ipAddressAsync(): Observable<string> {
    return ipAddressValue ? of(ipAddressValue) : ipAddressObservable;
  }
  public get ipAddress(): string {
    return ipAddressValue;
  }
}
